// src/app/Auth/api/authApi.js

import axios from "axios";

const API = axios.create({
  baseURL: "http://127.0.0.1:8000/api/accounts",
  headers: {
    "Content-Type": "application/json",
  },
});

export const signupUser = async (data) => {
  const response = await API.post("/signup/", data);
  return response.data;
};

export const loginUser = async (data) => {
  const response = await API.post("/login/", data);
  return response.data;
};